import type { PrevailingWagesTableRowVM } from 'ab-viewModels/accounting/prevailingWagesTable.viewModel';

export const toCSVData = (data: PrevailingWagesTableRowVM[]): Nullable<string>[][] => {
	const classificationCodes = data[0]?.columns ?? [];
	const header = ['Job Id', 'State', ...classificationCodes];

	const rows = data?.reduce((_acc, _item) => {
		let classificationCodeEmployeeCountMax = 0;
		for (let _index = 0; _index < classificationCodes.length; _index++) {
			const _employeesForClassificationCode = _item.classificationCodeMap?.[classificationCodes[_index]] ?? [];
			if (classificationCodeEmployeeCountMax < _employeesForClassificationCode.length) {
				classificationCodeEmployeeCountMax = _employeesForClassificationCode.length;
			}
		}
		for (let _index = 0; _index < classificationCodeEmployeeCountMax; _index++) {
			const _row = _index ? ['', ''] : [_item.jobCode, _item.jobState];
			for (let _ccIndex = 0; _ccIndex < classificationCodes.length; _ccIndex++) {
				const _employeesForClassificationCode = _item.classificationCodeMap?.[classificationCodes[_ccIndex]] ?? [];
				_row.push(_employeesForClassificationCode[_index] ?? '');
			}
			_acc.push(_row);
		}
		return _acc;
	}, [] as Nullable<string>[][]);

	return [header, ...rows];
};
